import type { IFilterChoiceItem } from '@/modules/universalStats/types/IFilterChoiceItem'

export function findLabelRecursive(
  nodes: IFilterChoiceItem[] | undefined,
  id: string | number,
): string | undefined {
  if (!nodes?.length) {
    return undefined
  }

  for (const node of nodes) {
    if (String(node.id) === String(id)) {
      return node.label
    }

    const found = findLabelRecursive(node.children, id)
    if (found) {
      return found
    }
  }

  return undefined
}

/** Ищет лейбл сначала в результатах поиска, затем в основных choices; иначе возвращает id строкой. */
export function resolveChoiceLabel(
  searchChoices: Record<string, IFilterChoiceItem[] | undefined>,
  filterChoices: Record<string, IFilterChoiceItem[] | undefined>,
  field: string,
  id: string | number,
): string {
  return (
    findLabelRecursive(searchChoices[field], id)
    || findLabelRecursive(filterChoices[field], id)
    || String(id)
  )
}
